import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import appActions from "../../redux/actions/app";
import TopbarUser from "./topbarUser";
import TopbarUserNotification from "./topbarNotification";
import TopbarWrapper from "./topbar.style";
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";


const { Header } = Layout;
const { toggleCollapsed } = appActions;
const customizedTheme = themes[themeConfig.theme].topbar;

class Topbar extends Component {
  render() {
    const { toggleCollapsed, userName, expirationTime, email } = this.props;
    const collapsed = this.props.collapsed && !this.props.openDrawer;
    const styling = {
      background: customizedTheme.backgroundColor,
      position: "fixed",
      width: "100%",
      height: 70
    };
    return (
      <TopbarWrapper>
        <Header
          style={styling}
          className={
            collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
          }
        >
          <div className="isoLeft">
            <button
              className={
                collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
              }
              style={{ color: customizedTheme.textColor }}
              onClick={toggleCollapsed}
            />
          </div>

          <ul className="isoRight" style={{ marginBottom: 0 }}>            
          <li
              onClick={() => this.setState({ selectedItem: "user" })}
              className="isoUser"
            >              
              <TopbarUserNotification />
            </li>
            <li style={{ fontWeight: "bold", cursor:'default', marginTop: 25 }}>
              { userName }
            </li>
            <li
              onClick={() => this.setState({ selectedItem: "user" })}
              className="isoUser"
            >              
              <TopbarUser />
            </li>                             
          </ul>
        </Header>       
      </TopbarWrapper>
    );
  }
}

export default connect(
  state => ({
    userName: state.auth.name,
    email: state.auth.email,
    expirationTime: state.auth.exp,
    ...state.app
  }),
  { toggleCollapsed }
)(Topbar);
